import BordableProperty from '../BordableProperty';

export default class EllipseSettingsProperty extends BordableProperty {

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    toStyle() {
        return {
            ...super.toStyle(),
            borderRadius: `50%`,
        }
    }
    
    toString() {
        return "设置";
    }
}
